import { render, staticRenderFns } from "./JobBasicInfoForm.vue?vue&type=template&id=58475d08&"
import script from "./JobBasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./JobBasicInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports